/* (c) Copyright Frontify Ltd., all rights reserved. */

import { MarkupElement } from '../../MarkupElement';

export class AlignRightMarkupElement extends MarkupElement {
    constructor(id = 'align-right') {
        super(id);
    }
}
